module.exports = __webpack_public_path__ + "img/13_debris.15717fc4.jpg";